var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"work",style:('background-image: url(\''+_vm.iSrc+'\')'),on:{"click":function($event){return _vm.linkto(_vm.nome)}}},[_c('div',{staticClass:"tag"},[_vm._v(_vm._s(_vm.tag))])])
}
var staticRenderFns = []

export { render, staticRenderFns }